export default __webpack_public_path__ + "static/char-s-12-cht-8c28f73ce9180c44db3d0f54c73c39f3.webp";